import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useLogin from "./useLogin";
import { PhoneInput } from "react-international-phone";
import { loginValidation } from "../register/utils/validation";
import { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const formData = [
  {
    id: 1,
    placeholder: "Phone",
    type: "text",
    name: "phone",
    label: "Phone Number",
  },
  {
    id: 2,
    placeholder: "Password",
    type: "password",
    name: "password",
    label: "Password",
  },
];

function Login() {
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    resolver: yupResolver(loginValidation),
    mode: "onBlur",
  });

  const { loginUserFn, isLogging, isErrorLogging } = useLogin();

  const onSubmit = (formData) => {
    loginUserFn(formData);
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-[#f8fafc] to-[#e0e7ef] py-8 px-4">
      <div className="w-full max-w-5xl bg-white rounded-2xl shadow-2xl px-12 py-8 flex flex-col items-center animate-fade-in">
        {/* Logo */}
        <img src="/zstore_logo.png" alt="Z-Store Logo" className="h-16 mb-6" />
        {/* Headline */}
        <h2 className="text-3xl font-bold text-gray-900 mb-2 text-center">
          Sign in to your account
        </h2>
        <p className="text-gray-500 mb-8 text-center text-base">
          Welcome back! Please enter your details to access your account.
        </p>

        <form
          className="w-full max-w-2xl flex flex-col gap-6"
          onSubmit={handleSubmit(onSubmit)}
        >
          {formData.map((item) => (
            <div key={item.id} className="flex flex-col">
              {/* Label */}
              <label
                htmlFor={item.id.toString()}
                className="text-gray-700 font-medium mb-2 text-base"
              >
                {item.label}
              </label>

              {/* Field */}
              {item.id === 1 ? (
                <div className="relative flex items-center h-[48px]">
                  {" "}
                  {/* Vertically center the phone input */}
                  <Controller
                    id={item.id.toString()}
                    name={item.name}
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <PhoneInput
                        value={value}
                        onChange={(val, country) => {
                          const dialCode = country?.country.dialCode || "";
                          let cleanNumber = val.replace(/\D/g, "");

                          if (!cleanNumber.startsWith(dialCode)) {
                            cleanNumber = `${dialCode}${cleanNumber}`;
                          }

                          if (cleanNumber.startsWith(`${dialCode}0`)) {
                            cleanNumber = `+${dialCode}${cleanNumber.slice(
                              dialCode?.length
                            )}`;
                          }

                          if (cleanNumber.startsWith(dialCode)) {
                            cleanNumber = `+${cleanNumber}`;
                          }

                          onChange(cleanNumber);
                        }}
                        placeholder="xxxx-xxxx xxxx"
                        defaultCountry="eg"
                        charAfterDialCode=""
                        className="w-full py-3 px-4 border-2 border-gray-200 rounded-lg bg-white text-gray-900 focus:outline-none focus:border-[#da0e1a] transition-colors text-base h-full"
                        inputClassName="w-full h-full"
                        inputStyle={{
                          background: "transparent",
                          border: "none",
                          color: "#000",
                          fontSize: "1rem",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                        countrySelectorStyleProps={{
                          buttonStyle: {
                            background: "transparent",
                            border: "none",
                            borderRight: "2px solid #e5e7eb",
                            padding: "0 1rem",
                            color: "#6b7280",
                            width: "4rem",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                          },
                        }}
                      />
                    )}
                  />
                </div>
              ) : (
                <div className="relative flex items-center">
                  <input
                    id={item.id.toString()}
                    className="w-full py-3 px-4 border-2 border-gray-200 rounded-lg bg-white text-gray-900 focus:outline-none focus:border-[#da0e1a] transition-colors text-base"
                    type={
                      item.type === "password" && showPassword
                        ? "text"
                        : item.type
                    }
                    placeholder={item.placeholder}
                    {...register(item.name, { required: true })}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    tabIndex={-1}
                  >
                    {showPassword && item.type === "password" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={20}
                        height={20}
                        viewBox="0 0 16 16"
                        fill="currentColor"
                      >
                        <path d="m10.12 10.827l4.026 4.027a.5.5 0 0 0 .708-.708l-13-13a.5.5 0 1 0-.708.708l3.23 3.23A6 6 0 0 0 3.2 6.182a6.7 6.7 0 0 0-1.117 1.982c-.021.061-.047.145-.047.145l-.018.062s-.076.497.355.611a.5.5 0 0 0 .611-.355l.001-.003l.008-.025l.035-.109a5.7 5.7 0 0 1 .945-1.674a5 5 0 0 1 1.124-1.014L6.675 7.38a2.5 2.5 0 1 0 3.446 3.446m-.74-.74A1.5 1.5 0 1 1 7.413 8.12zM6.32 4.2l.854.854Q7.564 5 8 5c2.044 0 3.286.912 4.028 1.817a5.7 5.7 0 0 1 .945 1.674q.025.073.035.109l.008.025v.003l.001.001a.5.5 0 0 0 .966-.257v-.003l-.001-.004l-.004-.013a2 2 0 0 0-.06-.187a6.7 6.7 0 0 0-1.117-1.982C11.905 5.089 10.396 4 8.002 4c-.618 0-1.177.072-1.681.199" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={20}
                        height={20}
                        viewBox="0 0 16 16"
                        fill="currentColor"
                      >
                        <path d="M8 6.003a2.667 2.667 0 1 1 0 5.334a2.667 2.667 0 0 1 0-5.334m0 1a1.667 1.667 0 1 0 0 3.334a1.667 1.667 0 0 0 0-3.334m0-3.336c3.076 0 5.73 2.1 6.467 5.043a.5.5 0 1 1-.97.242a5.67 5.67 0 0 0-10.995.004a.5.5 0 0 1-.97-.243A6.67 6.67 0 0 1 8 3.667" />
                      </svg>
                    )}
                  </button>
                </div>
              )}

              {/* Forgot password link below password field */}
              {item.id === 2 && (
                <div className="flex justify-end mt-1">
                  <Link
                    to="/forget-password"
                    className="text-sm text-[#da0e1a] hover:text-[#c40d17] underline"
                  >
                    Forgot password?
                  </Link>
                </div>
              )}

              {errors[item.name] && (
                <p className="text-red-500 text-sm mt-2 text-left">
                  {item.name === "phone"
                    ? "Please enter your phone number"
                    : "Please enter your password"}
                </p>
              )}
            </div>
          ))}

          <button
            type="submit"
            className="bg-gradient-to-r from-[#da0e1a] to-[#c40d17] rounded-lg w-full py-3 font-semibold text-xl cursor-pointer transition-colors hover:from-[#c40d17] hover:to-[#da0e1a] mb-2 text-white flex items-center justify-center gap-3"
            disabled={isLogging}
          >
            {isLogging && (
              <svg
                className="animate-spin h-6 w-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                ></path>
              </svg>
            )}
            {isLogging ? "Signing in..." : "Sign In"}
          </button>
        </form>

        {isErrorLogging && (
          <p className="text-red-600 text-sm mt-4">Internal Server Error</p>
        )}

        <div className="flex items-center w-full max-w-2xl my-6">
          <div className="flex-grow border-t border-gray-200"></div>
          <span className="mx-4 text-gray-400 text-sm">or</span>
          <div className="flex-grow border-t border-gray-200"></div>
        </div>

        <div className="flex items-center justify-center gap-3 text-lg w-full">
          <span className="text-gray-600">Don't have an account?</span>
          <Link
            to="/signup"
            className="underline text-[#da0e1a] hover:text-[#c40d17] font-medium"
          >
            Sign up
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
